export default __webpack_public_path__ + "static/media/box_center.f3a4ee9f.png";